import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    const institutionId = JSON.parse(localStorage.getItem('institution')).id

    const equipment = JSON.parse(sessionStorage.getItem('equipment'))
    if (equipment) {
      this.currentEquipment = equipment
      this.title = `do Equipamento - ${equipment.name}`
    }
    const contract = JSON.parse(sessionStorage.getItem('contract'))
    if (contract) {
      this.currentContract = contract
      this.title = `do Contrato - ${contract.number}`
    }
    const serviceOrder = JSON.parse(sessionStorage.getItem('serviceOrder'))
    if (serviceOrder) {
      this.currentServiceOrder = serviceOrder
      this.title = `da OS - ${serviceOrder.number}`
    }

    const calibrationPattern = JSON.parse(
      sessionStorage.getItem('calibrationPattern')
    )
    if (calibrationPattern) {
      this.isCalibration = true
      this.currentCalibrationPattern = calibrationPattern
      this.title = `do Padrão ${calibrationPattern.name} - ${calibrationPattern.certifiedNumber}`
      this.inputDisabled =
        (this.institution.userType > 3 && this.institution.userType != 8) ||
        this.currentCalibrationPattern.institutionId != institutionId
    } else {
      this.inputDisabled =
        this.institution.userType > 3 && this.institution.userType != 8
    }

    const calibrationV2Pattern = JSON.parse(
      sessionStorage.getItem('calibrationV2Pattern')
    )
    if (calibrationV2Pattern) {
      this.isCalibration = true
      this.currentCalibrationV2Pattern = calibrationV2Pattern
      this.title = `de ${calibrationV2Pattern.name} - ${calibrationV2Pattern.number}`
      this.inputDisabled =
        (this.institution.userType > 3 && this.institution.userType != 8) ||
        this.currentCalibrationV2Pattern.institutionId != institutionId
    } else {
      this.inputDisabled =
        this.institution.userType > 3 && this.institution.userType != 8
    }

    const electricalSafetyPattern = JSON.parse(
      sessionStorage.getItem('electricalSafetyPattern')
    )
    if (electricalSafetyPattern) {
      this.isCalibration = true
      this.currentElectricalSafetyPattern = electricalSafetyPattern
      this.title = `de ${electricalSafetyPattern.name} - ${electricalSafetyPattern.number}`
      this.inputDisabled =
        (this.institution.userType > 3 && this.institution.userType != 8) ||
        this.currentElectricalSafetyPattern.institutionId != institutionId
    } else {
      this.inputDisabled =
        this.institution.userType > 3 && this.institution.userType != 8
    }

    const labor = JSON.parse(sessionStorage.getItem('labor'))
    if (labor) {
      this.currentlabor = labor
      this.title = `da Tarefa - Num. ${labor.number}`
    }
    this.filterTable()
  },

  data: () => ({
    institution: {},
    currentlabor: {},
    currentElectricalSafetyPattern: {},
    isCalibration: false,
    title: '',
    message: '',
    deleteDialog: false,
    dialogKey: false,
    loading: false,
    tableLoading: false,
    firstValid: true,
    showSuccess: false,
    inputDisabled: false,
    expanded: [],
    documents: [],
    currentEquipment: {},
    currentContract: {},
    currentServiceOrder: {},
    currentCalibrationPattern: {},
    currentCalibrationV2Pattern: {},
    currentDocument: {},
    userLogged: {},
    certifiedNumber: '',
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      equipmentId: null,
      contractId: null,
      serviceOrderId: null,
      calibrationPatternId: null,
    },
    referenceName: null,
    fileName: null,
    fileType: null,
    fileSize: null,
    fileData: null,
    uploadDate: null,
    headers: [
      {
        text: '',
        value: '',
      },
      {
        text: 'Nome',
        align: 'center',

        value: 'referenceName',
      },
      {
        text: 'Certificado',
        align: 'center',

        value: 'certifiedNumber',
      },
      {
        text: 'Arquivo',
        align: 'center',

        value: 'fileName',
      },
      {
        text: 'Tipo',
        align: 'center',

        value: 'fileType',
        sortable: false,
      },
      {
        text: 'Tamanho',
        align: 'center',

        value: 'fileSize',
        sortable: false,
      },
      {
        text: 'Data',
        align: 'center',

        value: 'uploadDate',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',

        value: 'actions',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: '',
        align: 'center',
        value: '',
      },
      {
        text: 'Arquivo',
        align: 'center',

        value: 'fileName',
      },
      {
        text: 'Ações',
        align: 'center',

        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
  }),

  methods: {
    goBack() {
      const equipment = JSON.parse(sessionStorage.getItem('equipment'))
      if (equipment) {
        this.$router.push('/equipments')
      }

      const contract = JSON.parse(sessionStorage.getItem('contract'))
      if (contract) {
        this.$router.push('/contracts')
      }
      const serviceOrder = JSON.parse(sessionStorage.getItem('serviceOrder'))
      if (serviceOrder) {
      }

      const calibrationPattern = JSON.parse(
        sessionStorage.getItem('calibrationPattern')
      )
      const calibrationV2Pattern = JSON.parse(
        sessionStorage.getItem('calibrationV2Pattern')
      )

      const electricalSafetyPattern = JSON.parse(
        sessionStorage.getItem('electricalSafetyPattern')
      )

      if (calibrationPattern) {
        this.$router.push({
          path: '/calibration',
          query: { tab: 'pattern' },
        })
      }
      if (calibrationV2Pattern) {
        this.$router.push({
          path: '/calibration/v2',
          query: { tab: 'patternV2' },
        })
      }

      if (electricalSafetyPattern) {
        this.$router.push({
          path: '/electricalSafety',
          query: { tab: 'tabPattern' },
        })
      }

      const labor = JSON.parse(sessionStorage.getItem('labor'))
      if (labor) {
        this.$router.push('/tasks')
      }
    },

    importDocument() {
      if (this.$refs.firstForm.validate()) {
        this.loading = true
        var reader = new FileReader()
        reader.readAsDataURL(this.currentDocument)
        reader.onload = () => {
          this.fileData = reader.result
          this.upload()
        }
      }
    },

    validateDoc(document) {
      this.currentDocument = document
      const userSignature = JSON.parse(
        localStorage.getItem('user')
      ).signatureImage
      if (!document.validated) {
        if (userSignature) {
          this.apiService
            .get(`uploadDocument/validate/${this.currentDocument.id}`)
            .then(() => {
              this.filterTable()
              this.$toast.success('Arquivo validado com sucesso')
            })
        } else {
          this.$toast.error(
            'Assinatura não encontrada, verifique o cadastro de sua assinatura.'
          )
        }
      } else {
        this.$toast.error('Documento já validado!')
      }
    },

    getFile(document) {
      this.currentDocument = document
      if (this.currentDocument.filePath) {
        if (this.currentDocument.filePath.includes('equipacarefix.blob.core')) {
          const url = this.currentDocument.filePath
          window.open(url)
        } else {
          const url =
            process.env.VUE_APP_BASE_URL +
            this.currentDocument.filePath.replace('wwwroot/', '')
          window.open(url)
        }
      } else {
        this.getDocument()
      }
    },

    deleteFile(document) {
      this.currentDocument = document
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    filterTable() {
      this.filter.certifiedNumber = this.$route.query.certified
      this.filter.equipmentId = this.currentEquipment.id
      this.filter.contractId = this.currentContract.id
      this.filter.serviceOrderId = this.currentServiceOrder.id
      this.filter.laborId = this.currentlabor.id
      this.filter.calibrationPatternId = this.currentCalibrationPattern.id
      this.filter.calibrationV2PatternId = this.currentCalibrationV2Pattern.id
      this.filter.electricalSafetyPatternId =
        this.currentElectricalSafetyPattern.id
      this.updateTable()
    },

    async getDocument() {
      await this.apiService
        .get(`uploadDocument/${this.currentDocument.id}`)
        .then((response) => {
          const fileWindow = window.open()
          const url = 'data:application/pdf;base64,' + response.content.filepath

          fileWindow.document.write(
            `<html>
              <title>${this.currentDocument.fileName}.${this.currentDocument.fileType}</title>
              <body style:"overflow: hidden; margin: 0">
                <object width="100%" width="-webkit-fill-available" height="100%" height="-webkit-fill-available" type="application/pdf" data="${url}"></object>
              </body>
            </html>`
          )
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.currentDocument = {}
    },

    async updateTable() {
      this.tableLoading = true
      await this.apiService
        .post('uploadDocument/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.documents = response.content.documents
          this.tableLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async upload() {
      const document = {
        Id: this.currentDocument != null ? this.currentDocument.id : null,
        laborId: this.currentlabor != null ? this.currentlabor.id : null,
        EquipmentId:
          this.currentEquipment != null ? this.currentEquipment.id : null,
        ContractId: this.currentContract.id,
        ServiceOrderId: this.currentServiceOrder.id,
        CalibrationPatternId: this.currentCalibrationPattern.id,
        CalibrationV2PatternId: this.currentCalibrationV2Pattern.id,
        ElectricalSafetyPatternId: this.currentElectricalSafetyPattern.id,
        Name: this.referenceName,
        certifiedNumber: this.certifiedNumber,
        FileName: this.currentDocument.name,
        FileType: this.currentDocument.type.split('/')[1],
        Size: this.currentDocument.size,
        File: this.fileData,
      }

      await this.apiService
        .post('uploadDocument/add', document)
        .then((response) => {
          this.showSuccessAlert(response.message)
          this.loading = false
          this.$router.go()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
          this.loading = false
        })
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('uploadDocument/delete', this.currentDocument)
        .then((response) => {
          this.showSuccessAlert(response.message)
          this.updateTable()
          this.loading = false
          this.deleteDialog = false
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })

      this.currentDocument = {}
    },

    showSuccessAlert(message) {
      this.message = message

      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 4000)
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },
  },
}
